import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';
import { ShellLinkedServiceUtils } from './linked-service-utils';

@Metamodel.model({
    name: ModelConstants.serviceNowV2LinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate,
            getConnectorV2Name(shellStringResources.ServiceNow_DisplayText, isTridentInIframe())),
        format(shellStringResources.ModelName_LinkedServicesTemplate,
            getConnectorV2Name(shellStringResources.ServiceNow_DisplayText, isTridentInIframe()))
    ]
})
export class ServiceNowV2LinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly ENDPOINT: IAttribute;
    public static readonly USERNAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'ENDPOINT',
        templatable: true
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UserName,
        association: 'USERNAME',
        templatable: true
    })
    public username: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
        templatable: true
    })
    public password: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'CLIENT_SECRET',
        templatable: true
    })
    public clientSecret?: string | AzureKeyVault;

    // only supports 'password' for now, exists in payload only, no UI component
    public grantType?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): ServiceNowV2LinkedService {
        return ShellLinkedServiceUtils.removePassword(context, this) as ServiceNowV2LinkedService;
    }
}
